// extracted by mini-css-extract-plugin
export default {"fullWidth":"xo-z","image":"yo-z","lazyLoadPicture":"zo-z","lazyLoadSpinner":"Ao-z","lazyLoadSpin":"Bo-z","lazyLoadImage":"Co-z","hasStyledAspectRatio":"Do-z"};